export enum Estado {
    view = 0, insert = 1, edit = 2
}
